export default class ScrollToTop {
	constructor() {
		this.scrollTop = document.querySelector('.scroll-top');
		if (!this.scrollTop) return;
		this.content = document.getElementById('page-wrapper');

		if (!this.content) return;
		this.events();
	}

	events() {
		if (window.innerWidth >= 992) {
			window.addEventListener('scroll', () => {
					if (window.scrollY >= this.content.offsetTop) {
						this.scrollTop.classList.add('d-lg-flex');
					} else {
						this.scrollTop.classList.remove('d-lg-flex');
					}
				},
				false
			);

			this.scrollTop.addEventListener('click', (e) => {
					e.preventDefault();
					document.body.scrollIntoView({ behavior: 'smooth' });
				},
				false
			);
		}
	}
}

new ScrollToTop();
